import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTextInput from '../../CustomTextInput';
import ModalBody from '../ModalBody';

import DropDown, { OptionType } from '../../DropDown';

interface ModalProps {
    title: string;
    itemName: string;
    itemId: string;
    usageCount: number;
    replaceItems: OptionType[];
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    handleOk: (replaceId: string) => void;
}

const ReplaceItemAdminModal: React.FC<ModalProps> = ({ title, itemName, itemId, usageCount, replaceItems, handleOk, showModal, setShowModal }) => {
    const { t } = useTranslation();

    const [verificationText, setVerificationText] = useState('');
    const [selectedNewQuarry, setSelectedNewQuarry] = useState({ label: '', value: '' });

    return (
        <ModalBody
            title={t('quarry')}
            subTitle={`${t('replace')}`}
            description={itemName}
            closeText={t('cancel')}
            okText={t('validate')}
            open={showModal}
            handleClose={() => setShowModal(false)}
            disabledOk={!(verificationText === t('replace') && selectedNewQuarry.value.length)}
            handleOk={() => {
                handleOk(selectedNewQuarry.value);
            }}
        >
            <div className="w-300px pad-l-5px pad-r-5px pad-b-5px">{t('itemUsedXTimes', { count: usageCount })}</div>
            <DropDown
                inputLabel={t('by')}
                selectedItem={selectedNewQuarry}
                handleChange={(event, value) => value && setSelectedNewQuarry(value)}
                items={replaceItems.filter((value) => value.value !== itemId)}
            />
            <CustomTextInput
                value={verificationText}
                label={t('verificationReplaceText', { word: t('replace') })}
                onChange={(text) => setVerificationText(text)}
                required
            />
        </ModalBody>
    );
};

export default ReplaceItemAdminModal;
